export { default } from './FinanciamentoDePesados25';
